import GameVersion, {
  GameVersionCapability,
  gameVersionHas,
} from 'app/frontend/types/custom/GameVersion'

export type RawBullet =
  | string
  | {
      text: string
      requires?: GameVersionCapability
      excludes?: GameVersionCapability
    }

export const visibleBullets = (
  raw: RawBullet[],
  gameVersion: GameVersion,
): string[] =>
  raw
    .filter(
      (bullet) =>
        typeof bullet === 'string' ||
        ((!bullet.requires || gameVersionHas(bullet.requires, gameVersion)) &&
          (!bullet.excludes || !gameVersionHas(bullet.excludes, gameVersion))),
    )
    .map((bullet) => (typeof bullet === 'string' ? bullet : bullet.text))
